import {
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  Inject,
  Injectable
} from '@angular/core';
import {
  Observable,
  catchError,
  switchMap,
} from 'rxjs';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import {
  InvalidSessionError,
  MissingSessionError
} from "@shared/models/token-error";
import { CompanyRouteService } from './company-route.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    const isApiUrl = request.url.startsWith(this.apiUrl);

    if(!isApiUrl) {
      return next.handle(request);
    }

    return this.authService.getToken()
      .pipe(
        switchMap(token => {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          });

          if (this.companyRouteService.companyId) {
            request = request.clone({
              setHeaders: { 'Company-Id': this.companyRouteService.companyId.toString() },
            });
          }
          
          return next.handle(request);
        }),
        catchError(err => {
          if(err instanceof InvalidSessionError || err instanceof MissingSessionError) {
            this.router.navigate(["/login"]);
          }

          if(err instanceof HttpErrorResponse && err.error === "invalid-session") {
            this.authService.logout().subscribe({
              complete: () => {
                this.router.navigate(["/login"]);
              }
            });
          }

          throw err;
        })
      );
  }

  constructor(
    private authService: AuthService,
    private companyRouteService: CompanyRouteService,
    private router: Router,
    @Inject('BASE_URL') private apiUrl: string
  ) {}
}
